import { render, staticRenderFns } from "./confirmar_identidad.vue?vue&type=template&id=18ce6e5e&scoped=true"
import script from "./confirmar_identidad.vue?vue&type=script&lang=js"
export * from "./confirmar_identidad.vue?vue&type=script&lang=js"
import style0 from "./confirmar_identidad.vue?vue&type=style&index=0&id=18ce6e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ce6e5e",
  null
  
)

export default component.exports